import { EmptyStateNotificationsImage } from 'common/images';

import * as Styled from './notification-empty-state.style';

interface NotificationEmptyStateProps {
  title: string;
  description: string;
}

const NotificationEmptyState = ({
  title,
  description,
}: NotificationEmptyStateProps) => {
  return (
    <Styled.Wrapper data-testid="empty-state">
      <Styled.Content>
        <Styled.IllustrationWrapper>
          <EmptyStateNotificationsImage />
        </Styled.IllustrationWrapper>
        <Styled.TextWrapper>
          <Styled.Title>{title}</Styled.Title>
          <Styled.Description>{description}</Styled.Description>
        </Styled.TextWrapper>
      </Styled.Content>
    </Styled.Wrapper>
  );
};

export { NotificationEmptyState };
